import { withdrawArrA, channelArr, cashbackLimit, inviteLimitAmount, joinGameLimit, betLimit, vipLimit, vipChargeNum, vip2ChargeNum, lastWithdrawArr } from "./gameConfig";

const channel = process.env.VUE_APP_CHANNEL;

/**当前渠道配置 */
const currentChannel = channelArr[channel];
/**当前提现列表A版 */
const currentWithdrawDataA = withdrawArrA[channel];
/**最后显示的提现列表B版 */
const lastWithdrawData = lastWithdrawArr[channel];
/**分享获取下级达到金额可领取奖励 */
const currentInviteLimitAmount = inviteLimitAmount[channel];
/**当前未充值玩家亏损提示金额 */
const currentCashbackLimit = cashbackLimit[channel];
/**当前进入游戏的金额限制 */
const currrentJoinGameLimit = joinGameLimit[channel];
/**当前升级vip1需要达到的下注限制条件 */
const currentBetLimit = betLimit[channel];
/**当前vip下注需要的最高进度 */
const currentVipLimit = vipLimit[channel];
/**升级vip1需要充值金额 */
const currentVipChargeNum = vipChargeNum[channel];
/**升级vip2需要充值金额 */
const currentVip2ChargeNum = vip2ChargeNum[channel];

export {
    currentChannel,
    currentWithdrawDataA,
    currentCashbackLimit,
    currentInviteLimitAmount,
    currrentJoinGameLimit,
    currentBetLimit,
    currentVipLimit,
    currentVipChargeNum,
    currentVip2ChargeNum,
    lastWithdrawData
}